import { makeStyles } from '@material-ui/styles'
import DocumentMeta from 'core/components/DocumentMeta'
import PollingData from 'core/components/PollingData'
import Progress from 'core/components/progress/Progress'
import useListAction from 'core/hooks/useListAction'
import useScopedPreferences from 'core/session/useScopedPreferences'
import Theme from 'core/themes/model'
import { listNamespaces } from 'k8s/components/resources/namespaces/actions'
import { K8sPluginGlobalPrefs } from 'k8s/model'
import React from 'react'
import { useSelector } from 'react-redux'
import { listKaapiClusters } from '../kaapi/clusters/actions'
import { kaapiClustersOverviewSelector } from '../kaapi/clusters/selectors'
import ClustersDashboardHeader from './ClustersDashboardHeader'
import ClustersLandingPage from './ClustersLandingPage'
import DeployNewCluster from './DeployNewCluster'
import ListK8sClusters from './ListK8sClusters'

const ClustersDashboardPage = () => {
  const classes = useStyles({})
  const { prefs: k8sPluginGlobalPerfs } = useScopedPreferences<K8sPluginGlobalPrefs>(
    'k8sPluginGlobalParams',
  )
  const clusterId = k8sPluginGlobalPerfs?.clusterId
  useListAction(listNamespaces, {
    params: { clusterId },
    requiredParams: ['clusterId'],
  })
  const { loading: loadingKaapiClusters, reload } = useListAction(listKaapiClusters, {
    initialLoadingState: true,
  })
  const clusters = useSelector(kaapiClustersOverviewSelector)

  // Landing page for empty state
  const showLandingPage = !loadingKaapiClusters && !clusters?.length

  return (
    <>
      <DocumentMeta title="Dashboard" breadcrumbs />
      <Progress loading={loadingKaapiClusters}>
        <PollingData
          hidden
          loading={loadingKaapiClusters}
          onReload={reload}
          refreshDuration={1000 * 10}
        />
        {showLandingPage ? (
          <ClustersLandingPage />
        ) : (
          <>
            {!loadingKaapiClusters && <DeployNewCluster />}
            <ClustersDashboardHeader />
            <div className={classes.headerSubText}>
              <ListK8sClusters />
            </div>
          </>
        )}
      </Progress>
    </>
  )
}

export default ClustersDashboardPage

const useStyles = makeStyles((theme: Theme) => ({
  customGridContainer: {
    display: 'grid',
    gridTemplateColumns: '370px 1fr',
    gridGap: '24px',
  },
  headerSubText: {
    paddingTop: '24px',
  },
}))
